import * as React from "react";
import { OutlinedInput as MuiOutlinedInput } from "@mui/material";
import { getIn } from "formik";

export function fieldToOutlinedInput({
    disabled,
    field: { onBlur: fieldOnBlur, ...field },
    form: { isSubmitting, touched, errors },
    onBlur,
    ...props
}) {
    const fieldError = getIn(errors, field.name);
    const showError = getIn(touched, field.name) && !!fieldError;

    return {
        error: showError,
        disabled: disabled ?? isSubmitting,
        onBlur:
            onBlur ??
            function (e) {
                fieldOnBlur(e ?? field.name);
            },
        ...field,
        ...props,
    };
}

export function OutlinedInput({ children, ...props }) {
    return <MuiOutlinedInput {...fieldToOutlinedInput(props)}>{children}</MuiOutlinedInput>;
}

OutlinedInput.displayName = "FormikMuiOutlinedInput";
